import * as React from 'react';
import { MenuItem } from 'sos-common/js/components/MobileMenu/MobileMenu.types';
import MobileMenu from 'sos-common/js/components/MobileMenu/MobileMenu';
import { SiteFunctions } from './SiteFunctions';
import { ISelectListItem } from './ISelectListItem';

export interface ISiteMenuProps {
  menuIsOpen: boolean;
  menuId: string;
  currentPageId: number;
  isStartPage: boolean;
  treeNodes: MenuItem;
  siteMapUrl: string;
  minorityLanguages: ISelectListItem[];
  translatedItems: ISelectListItem[];
  translatedStartPageItems: ISelectListItem[];
  startPageid: number;
  language: string;
  isCampaignPage: boolean;
}

export interface ISiteMenuState {}

export class SiteMenu extends React.Component<ISiteMenuProps, ISiteMenuState> {
  constructor(props: ISiteMenuProps) {
    super(props);
    this.state = {};
  }

  render(): JSX.Element {
    return (
      <div
        aria-hidden={!this.props.menuIsOpen}
        className={`site-menu ${this.props.menuIsOpen ? 'site-menu--open' : ''}`}
        id={this.props.menuId}>
        <MobileMenu
          language={this.props.language}
          currentPageId={this.props.currentPageId}
          isStartPage={this.props.isStartPage}
          treeNodes={this.props.treeNodes}
          startPageId={this.props.startPageid}
          isCampaignPage={this.props.isCampaignPage}
        />

        <SiteFunctions
          siteMapUrl={this.props.siteMapUrl}
          minorityLanguages={this.props.minorityLanguages}
          translatedItems={this.props.translatedItems}
          translatedStartPageItems={this.props.translatedStartPageItems}
        />
      </div>
    );
  }
}
